import { jsxs as x, Fragment as L, jsx as t } from "react/jsx-runtime";
import { Select as s, Col as u } from "antd";
import { u as h } from "./styled-components.browser.esm-BFmoFexH.js";
import { withSortableElement as R, IconContainer as E } from "@biron-data/react-components";
import * as o from "react";
import { useLanguageResolver as O } from "@biron-data/react-contexts";
import { useGridLayout as f } from "./selector/metrics/hooks.js";
import { useSelectorLayout as C } from "./layout/useSelectorLayout.js";
function F(r, n) {
  return /* @__PURE__ */ o.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, r), /* @__PURE__ */ o.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
  }));
}
const M = o.forwardRef(F);
function I(r, n) {
  return /* @__PURE__ */ o.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, r), /* @__PURE__ */ o.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
  }));
}
const B = o.forwardRef(I), p = ({
  groupedOptions: r,
  offset: n,
  id: a,
  value: e,
  onChange: g,
  onDirectionChange: l,
  isDefault: w,
  ...S
}) => {
  const b = O(), c = C(), k = f(c, { span: 13 }, { span: 22 }), $ = f(c, { span: 2 }, { span: 1 });
  return /* @__PURE__ */ x(L, { children: [
    /* @__PURE__ */ t(P, { ...k, $isdefault: w ? 1 : 0, offset: n, children: /* @__PURE__ */ t(
      G,
      {
        ...S,
        value: e == null ? void 0 : e.value,
        onChange: g,
        virtual: !1,
        defaultValue: void 0,
        children: Object.entries(r).map(
          ([i, m]) => m && /* @__PURE__ */ t(
            s.OptGroup,
            {
              label: b.get(`configuration-label-${i}`),
              children: m.map(
                ({ label: y, value: d, disabled: v }, j) => /* @__PURE__ */ t(s.Option, { value: d, disabled: v, children: y }, `${d}-${j}`)
              )
            },
            `${i}-groupName-${a}`
          )
        )
      },
      `no-sort-StyledSelect-${a}`
    ) }),
    /* @__PURE__ */ t(u, { ...$, children: (e == null ? void 0 : e.value) && /* @__PURE__ */ t(E, { clickable: !0, onClick: () => {
      l == null || l(!e.asc);
    }, children: e.asc ? /* @__PURE__ */ t(M, {}) : /* @__PURE__ */ t(B, {}) }) })
  ] });
};
p.Sortable = R(p);
const G = h(s)`
    width: 100%;
`, P = h(u)`
    ${(r) => r.$isdefault ? `
  font-style: italic;
  color: var(--light-grey);
  
  .ant-select-selection-item{
    color: var(--light-grey);
  }
  ` : ""}
`;
export {
  B as F,
  p as S,
  M as a
};
//# sourceMappingURL=SortSelectorSelect-DSr3KYi4.js.map
